module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-panel padded text-center"
  }, [_c('chart', {
    attrs: {
      "includeTotals": true,
      "path": "/api/people/GetChartSales"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6eb67b71", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb67b71"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/categories/CategoryOverview.vue
// module id = 1306
// module chunks = 0